export interface CatalogMoldSize {
  MoldSizeId: number | null;
  MoldSizeName: string | null;
  MinSpeedLimit: number | null;
  Height: number | null;
  Width: number | null;
  Code: string | null;
  LbsPerInch: number | null;
  Section: number | null;
  Enabled: boolean;
  IsActive: boolean;
}
export const CATALOG_MOLD_SIZE_INITIAL_VALUES: CatalogMoldSize = {
  MoldSizeId: null,
  MoldSizeName: "",
  MinSpeedLimit: 0,
  Height: 0,
  Width: 0,
  Code: "",
  LbsPerInch: 0,
  Section: 0,
  Enabled: true,
  IsActive: true,
};
